module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Abbreviations of journals and series are those used regularly in the scholarly literature. For details please see "), _c('i', [_vm._v("The SBL Handbook of Style")]), _vm._v(", ed. P. H. Alexander "), _c('i', [_vm._v("et al.")]), _vm._v(" (Peabody, MA, Hendrickson, 1999), pp. 121–52. Help can also be found in the lists printed annually in the "), _c('i', [_vm._v("Catholic Biblical Quarterly")]), _vm._v(" (end of pt 4) and "), _c('i', [_vm._v("New Testament Abstracts")]), _vm._v(" (start of pt 1).")]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Ante-Nicene Christian Library")]), _vm._v(", ed. A. Roberts and J. Donaldson")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("AV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Authorized Version (King James Version)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Bib. Inst.")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Biblical Institute Press (Pontificio Istituto Biblico, Rome)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ESV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ET")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("English translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("et al.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("et alibi")]), _vm._v(" (and other places), "), _c('i', [_vm._v("et alii")]), _vm._v(" (and others)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("f.")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("and page/verse/etc. immediately following")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("GNB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Good News Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ICC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("ISBE")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("International Standard Bible Encyclopedia")]), _vm._v(" (rev. edn), ed. G. W. Bromiley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Jerusalem Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JSHJ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal for the Study of the Historical Jesus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LNTS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Library of New Testament Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LSJ")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Liddell and Scott, "), _c('i', [_vm._v("Greek-English Lexicon")]), _vm._v(" (rev. edn), ed. H. S. Jones and R. McKenzie")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LXX")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Septuagint (Old Testament in Greek)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NEB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New English Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NIV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NJB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New Jerusalem Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers")]), _vm._v(", ed. P. Schaff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("par.")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("and parallel(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("REB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Revised English Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("RGG")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Die Religion in Geschichte und Gegenwart")]), _vm._v(", ed. K. Galling")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("RSV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBL")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Society for Biblical Literature")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('i', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(", ed. G. Kittel (tr. and ed. G. W. Bromiley)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("TSAJ")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Texts and Studies in Ancient Judaism")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("UBS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("United Bible Societies")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06801598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 78
// module chunks = 0